export default "__VITE_ASSET__C9HNWMgB__"